import { Message } from "../../types/types";
import { useRef, useState } from "react";
import styles from "./PromotionalMessageItem.module.scss";
import { PromotionalCountdownTimer } from "./PromotionalCountdownTimer/PromotionalCountdownTimer";
import { PromotionalMessage } from "../../types/prodcatBaseTypes";

type CountDownTimerDate = {
  year: number;
  month: number;
  day: number;
};

type Props = {
  message: Message;
  showPromoTimerVariant: string;
  countdownTimerEnd: CountDownTimerDate;
  countdownTimerAvailabileToOrder: boolean;
};

export const PromotionalMessageItem = ({
  message,
  showPromoTimerVariant,
  countdownTimerEnd,
  countdownTimerAvailabileToOrder,
}: Props) => {
  const [showInfo, setShowInfo] = useState(false);
  const infoButtonRef = useRef<HTMLButtonElement>(null);

  const handleTooltipExpandClick = () => {
    setShowInfo(!showInfo);
    infoButtonRef.current?.focus();
  };
  const handleTooltipCollapseClick = () => setShowInfo(false);

  return (
    <>
      <div className={styles.messageContainer}>
        <p className={styles.message}>{message.title}</p>
        {message.description ? (
          <button
            data-testid="product:delivery-service:tooltip:button:expand"
            ref={infoButtonRef}
            onClick={handleTooltipExpandClick}
            className={styles.promoToolTip}
            aria-label={`${message.title} information`}
          />
        ) : null}
        {showPromoTimerVariant?.length > 0 && showPromoTimerVariant !== "C" && (
          <PromotionalCountdownTimer
            year={countdownTimerEnd.year}
            month={countdownTimerEnd.month}
            day={countdownTimerEnd.day}
            message={message as PromotionalMessage}
            availableToOrder={countdownTimerAvailabileToOrder}
            showPromoTimerVariant={showPromoTimerVariant}
          />
        )}
      </div>
      <div
        data-testid="product:promotional-message:tooltip"
        className={showInfo ? styles.infoBlock : styles.infoBlockHide}
      >
        <button
          aria-label="Collapse tooltip"
          data-testid="product:promotional-message:tooltip:button:collapse"
          onClick={handleTooltipCollapseClick}
          className={styles.closeButton}
        />
        <div aria-live="polite" className={styles.tip}>
          <div dangerouslySetInnerHTML={{ __html: `${message.description}` }} />
        </div>
      </div>
    </>
  );
};
